import React from 'react';
import PropTypes from 'prop-types';
import { compose, bindActionCreators } from 'redux';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Assignment from '@mui/icons-material/Assignment';
import { getOfferPartnerIncomeData, getIncomeDataIsLoaded, getIncomeDataIsValid, getIncomeDataIsSaving } from '../selectors';
import OfferPartnerIncomeDataListComponent from './OfferPartnerIncomeDataListComponent';
import OfferPartnerSalaryDataContainer from './OfferPartnerSalaryDataContainer';
import {
  loadOfferPartnerIncomeData,
  loadOfferPartnerSalaryData,
  updatePartnerIncomeData,
  loadIncomeDataDetailOptions
} from '../actionCreators';
import { CollapseCard } from '@totalsoft/rocket-ui';

class OfferPartnerIncomeDataContainer extends React.PureComponent {
  state = {
    expanded: false,
    editable: false,
    data: this.props.data,
    dirty: false
  };

  componentDidUpdate(prevProps) {
    if (prevProps.isLoaded !== this.props.isLoaded && !this.props.isLoaded) {
      if (this.props.isSalary) {
        this.loadSalaryData();
      } else {
        this.loadIncomeData();
      }
      return;
    }
    if (prevProps.data !== this.props.data) {
      if (this.props.isLoaded) {
        this.setState({ data: this.props.data });
      }
      //if data is invalid and the card is expanded -> load data
      if (!this.props.isValid && this.state.expanded) {
        if (this.props.isSalary) {
          this.loadSalaryData();
        } else {
          this.loadIncomeData();
        }
      }
    }
  }

  componentDidMount() {
    if (this.props.isSalary) {
      this.loadSalaryData();
    } else {
      this.loadIncomeData();
    }
  }
  loadIncomeData = async () => {
    const { actions, documentId, siteId, incomeTypeId, partnerId, isAssociatedPartner } = this.props;
    await actions.loadOfferPartnerIncomeData(documentId, siteId, incomeTypeId, partnerId, isAssociatedPartner);
  };

  loadSalaryData = async () => {
    const { actions, documentId, siteId, incomeTypeId, partnerId, isAssociatedPartner } = this.props;
    await actions.loadOfferPartnerSalaryData(documentId, siteId, incomeTypeId, partnerId, isAssociatedPartner);
  };

  loadDetailOptions = detailId => {
    return this.props.actions.loadIncomeDataDetailOptions(detailId);
  };

  onEdit = () => {
    this.setState({ editable: true });
  };

  onCancel = () => {
    this.setState({ editable: false, data: this.props.data });
  };

  onSave = async () => {
    const { incomeTypeId, documentId, siteId, partnerId, isAssociatedPartner } = this.props;
    var data = {
      incomeTypeId,
      values: this.state.data,
      documentId,
      siteId,
      partnerId
    };

    try {
      let event = await this.props.actions.updatePartnerIncomeData(data, isAssociatedPartner);
      if (event.ok) {
        this.setState({ editable: false });
      }
    } catch (error) {
      // continue regardless of error
    }
  };

  onChange = (detailId, value) => {
    const index = this.state.data.findIndex(x => x.incomeTypeDetailId === detailId);
    const detail = this.state.data[index];
    const newDetail = Object.assign({}, detail, { value });

    const data = [...this.state.data.slice(0, index), newDetail, ...this.state.data.slice(index + 1)];
    this.setState({ data });
  };

  onPeriodChange = (detailId, period) => {
    const index = this.state.data.findIndex(x => x.incomeTypeDetailId === detailId);
    const detail = this.state.data[index];
    const newDetail = Object.assign({}, detail, { period });

    const data = [...this.state.data.slice(0, index), newDetail, ...this.state.data.slice(index + 1)];
    this.setState({ data });
  };

  render() {
    const { title, incomeTypeId, isSalary, documentId, siteId, partnerId, fromExternalSource, saving, index } = this.props;
    const { expanded, editable, data } = this.state;
    return (
      data.length > 0 && (
        <CollapseCard id={'offerPartnerIncomeDataCard_' + index} icon={Assignment} title={title} expanded={expanded} toggleOnHeaderClick>
          <>
            {data && !isSalary && (
              <OfferPartnerIncomeDataListComponent
                cardIndex={index}
                loadDetailOptions={this.loadDetailOptions}
                data={data}
                editable={editable}
                onEdit={this.onEdit}
                onCancel={this.onCancel}
                onSave={this.onSave}
                onChange={this.onChange}
                onPeriodChange={this.onPeriodChange}
                partnerId={partnerId}
                fromExternalSource={fromExternalSource}
                saving={saving}
              />
            )}

            {data && isSalary && (
              <OfferPartnerSalaryDataContainer
                cardIndex={index}
                loadDetailOptions={this.loadDetailOptions}
                data={data}
                editable={editable}
                onEdit={this.onEdit}
                onSave={this.onSalarySave}
                onChange={this.onChange}
                documentId={documentId}
                siteId={siteId}
                partnerId={partnerId}
                incomeTypeId={incomeTypeId}
                fromExternalSource={fromExternalSource}
                saving={saving}
              />
            )}
          </>
        </CollapseCard>
      )
    );
  }
}

OfferPartnerIncomeDataContainer.propTypes = {
  actions: PropTypes.object.isRequired,
  t: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  documentId: PropTypes.number.isRequired,
  siteId: PropTypes.number.isRequired,
  incomeTypeId: PropTypes.number.isRequired,
  offerHeader: PropTypes.object.isRequired,
  isSalary: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
  isLoaded: PropTypes.bool.isRequired,
  isValid: PropTypes.bool.isRequired,
  isAssociatedPartner: PropTypes.bool,
  partnerId: PropTypes.number.isRequired,
  fromExternalSource: PropTypes.bool.isRequired,
  saving: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired
};

function mapStateToProps(state, ownProps) {
  return {
    data: getOfferPartnerIncomeData(state, ownProps.partnerId, ownProps.incomeTypeId),
    isLoaded: getIncomeDataIsLoaded(state, ownProps.partnerId, ownProps.incomeTypeId),
    isValid: getIncomeDataIsValid(state, ownProps.partnerId, ownProps.incomeTypeId),
    saving: getIncomeDataIsSaving(state, ownProps.partnerId, ownProps.incomeTypeId),
    offerHeader: state.currentOffer.header
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      { loadOfferPartnerIncomeData, loadOfferPartnerSalaryData, loadIncomeDataDetailOptions, updatePartnerIncomeData },
      dispatch
    ),
    dispatch
  };
}

export default compose(connect(mapStateToProps, mapDispatchToProps), withTranslation())(OfferPartnerIncomeDataContainer);
